__turbopack_context__.v({
  "accordion": "index-module-scss-module__l6f_eq__accordion",
  "body": "index-module-scss-module__l6f_eq__body",
  "controlInput": "index-module-scss-module__l6f_eq__controlInput",
  "header": "index-module-scss-module__l6f_eq__header",
});
